import Switch from 'antd/es/switch';
import styled from 'styled-components';
import { ifProp, theme } from 'styled-tools';

const SwitchAccountTypeWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 90%;
  padding: 12px 30px;
  line-height: 1;

  background: ${(props) => props.theme.colors.background.modalBackground};
  border-radius: ${(props) => props.theme.sizing.borderRadius};

  background: ${(props) => props.theme.colors.background.modalBackground};
  border-radius: ${(props) => props.theme.sizing.borderRadius};
`;

const RealDemo = styled.div`
  position: relative;
  font-size: 18px;
  cursor: pointer;
  font-weight: ${ifProp('active', 'bold', '500')};
  transition: all 0.2s ease-in-out;
  color: ${({ active, demo }) =>
    demo ? theme('colors.background.primaryColor') : theme('utils.accent')};
`;

const FancySwitch = styled(Switch)`
  &.ant-switch {
    width: 100%;
    margin: 0 10px;
    max-width: 60px;
    background-color: ${theme('primaryColor')};
    &:focus {
      box-shadow: ${ifProp(
        'checked',
        '0 0 0 2px rgb(254 145 72 / 30%)',
        '0 0 0 2px rgb(44 156 219 / 30%)'
      )};
    }
  }
  &.ant-switch-checked {
    background-color: ${(props) => props.theme.utils.accent};
  }
`;

export const S = { SwitchAccountTypeWrapper, RealDemo, FancySwitch };
